/* eslint-disable max-len */
/* globals injectedConfiguratorSettings */

// Only access injectedConfiguratorSettings on client side
const config = () => {
  if (typeof window !== 'undefined' && typeof injectedConfiguratorSettings !== 'undefined') {
    return {
      ...injectedConfiguratorSettings,
    };
  }
  return {};
};

export default config;
